import React, { Component } from "react";
//// componentes reutilizables
import TecladoPin from "../../../generico/TecladoPin";
import TransferInterbancaService from "../../../../services/transferencias/TransferInterbancaService";
import NumberFormat from "react-number-format";
import md5 from "md5";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import AuthService from "../../../../services/login/auth.service";
import { MENSAJE } from "../../../generico/utils/Constantes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

export default class TransferenciaInterbancaria extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.tecladoPinRef = React.createRef();
  }

  getInitialState = () => ({
    pin: "",
    nroOperacion: 0,
    disableSgte: true,
  });

  resetState = () => {
    this.setState(this.getInitialState());
    this.tecladoPinRef.current.limpiarPin();
  };

  confirmarTransferencia = (titulo, mensaje, callback) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "No",
            className: "",
            action: function () {
              Popup.close();
            },
          },
          {
            text: "Si",
            className: "success",
            action: function () {
              callback();
              Popup.close();
            },
          },
        ],
      },
    });

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  pinValue = (value) => {
    this.setState({
      pin: value,
    });
    this.enableNext(value);
  };

  enableNext(pin) {
    if (pin !== "" && pin.length === 6) {
      this.state.disableSgte = false;
    } else {
      this.state.disableSgte = true;
    }
  }

  confirmar = (e, transferenciaDatosRepetidos = false) => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    var importe = this.props.importe.split(".").join("");
    importe = String(importe).replace(/\,/g, ".");

    trackPromise(
      TransferInterbancaService.confirmarTransferenciaInterbancaria(
        parseFloat(importe),
        this.props.cuentaOrigen.moneda,
        this.props.motivo,
        parseInt(this.props.cuentaOrigen.ahorro),
        "CI",
        AuthService.getSocio().nombreCompleto.trim(),
        this.props.cuentaDestino.codEntidad,
        this.props.cuentaDestino.nroCuenta,
        this.props.cuentaDestino.tipoDocDestino,
        this.props.cuentaDestino.docDestino,
        this.props.cuentaDestino.titular,
        md5(this.state.pin),
        transferenciaDatosRepetidos
      ).then((response) => {

        //// Habilita boton
        this.btn.removeAttribute("disabled");
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codigo === 0) {
          var nroOperacion = jData.datos;
          this.resetState();
          this.props.returnDataPaso3(nroOperacion);
          this.props.nextStep();
        } else if (jData.codigo === 3) {
          Popup.queue(this.confirmarTransferencia("Atención", MENSAJE.CONFIRMAR_TRANSFERENCIA, (e) => this.confirmar(e, true)));
        } else {
          Popup.queue(this.notifiPopup("Info", jData.mensaje));
        }
      })
    ).catch((error) => {
      //// Habilita boton
      console.log(error);
      this.btn.removeAttribute("disabled");
      Popup.queue(this.notifiPopup(
        "Error",
        "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste."
      ));
    });
  };
  render() {
    return (
      <div>
        <form id="idFormPaso3" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Selección de Cuentas
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Transferencia</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8">
                <div className="col-8" style={{ marginBottom: 5 }}>
                  <h6 className="item-vef" style={{ margin: 0 }}>
                    Cuenta: {this.props.cuentaOrigen.ahorro} -{" "}
                    {AuthService.getSocio().nombreCompleto.trim()}
                  </h6>
                  <p className="item-vef" style={{ marginBottom: 0 }}>
                    Tipo: {this.props.cuentaOrigen.descripcion}
                  </p>
                  <p className="item-vef">Moneda: {this.props.cuentaOrigen.moneda}</p>
                </div>
              <div className="row invoice-info">
                <div className="col-12">
                  <div className="table-responsive">
                    {this.props.cuen}
                    <table className="table">
                      <tbody>
                        <tr>
                          <th>Cuenta Crédito:</th>
                          <td>{this.props.cuentaDestino.nroCuenta}</td>
                        </tr>
                        <tr>
                          <th>Importe del Crédito:</th>
                          <td>
                            <NumberFormat
                              value={this.props.importe}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                            />{" "}
                            {this.props.cuentaOrigen.moneda}.
                          </td>
                        </tr>
                        <tr>
                          <th>Titular de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.titular}</td>
                        </tr>
                        <tr>
                          <th>Tipo documento de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.tipoDocDestino}</td>
                        </tr>
                        <tr>
                          <th>Documento de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.docDestino}</td>
                        </tr>
                        <tr>
                          <th>Entidad:</th>
                          <td>{this.props.cuentaDestino.entidad}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
                <div className="invoice p-3 mb-3 teclados">
                  <TecladoPin
                    pinValue={this.pinValue.bind(this)}
                    label="Ingrese el Pin de Transacción"
                    ref={this.tecladoPinRef}
                  />
                </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12 callout  importante">

            <div className="col-lg-10 col-md-12">
              <i
                className="fas fa-exclamation-circle card-fa-icono-info"
                style={{ marginRight: 5, fontSize: 25 }}
              />
              <p style={{ fontSize: 20 }}>Importante!</p>
            </div>

            <div >

              - El horario de SIPAP para envío de transacciones es
              de 09:00hs a 17:00hs. Los pagos enviados posterior
              al horario de SIPAP serán procesados al siguiente
              día hábil.
              <br />
              - El límite diario es de 10.000.000 Gs. y el límite
              mensual es de 50.000.000 Gs
              <br />
              - Cantidad de operaciones sin costo: 7<br />
              - Monto a descontar al exceder las 7 operaciones:
              5.500 Gs.
              <br />
              - Todas las operaciones realizadas son de exclusiva
              responsabilidad del socio, en caso de errores en la
              imputación de las transferencias, las reversiones
              dependen de la aprobación de la entidad receptora.
              <br />

            </div>
          </div>

          <hr />
          <div className="row">
            <div className="col-lg-6 col-md-6"></div>
            <div className="col-lg-3 col-md-3 btn-consulta">
              <button
                className="btn btn-cu-quintary"
                onClick={this.props.previousStep}
              >
                <FontAwesomeIcon icon={faArrowLeft} />  Volver
              </button>

            </div>
            <div className="col-lg-3 col-md-3">
              <button
                ref={(btn) => { this.btn = btn; }}
                className="btn btn-cu-primary"
                disabled={this.state.disableSgte}
                onClick={this.confirmar}
              >
                Confirmar Transferencia <FontAwesomeIcon icon={faArrowRight} />
              </button></div>

          </div>
         
        </form >
      </div >
    );
  }
}
